interface ListPagination {
  total?: number;
  last_page?: number;
}

/**
 * Pager total from a paginated list response.
 * `total` alone hides the pager when it is smaller than the UI page size,
 * even if `last_page` says there are more pages.
 */
export const resolveListTotal = (
  pagination: ListPagination | null | undefined,
  itemsLength: number,
  limit: number
) => {
  const serverTotal = pagination?.total ?? 0;
  const lastPage = pagination?.last_page ?? 1;
  if (lastPage <= 1) return serverTotal;
  return Math.max(serverTotal, (lastPage - 1) * limit + itemsLength);
};
